// Vertical-aware nouns: the same platform speaks each industry's language.
// Fed by GET /api/lps/org/vertical (cached), used by nav + pages.
const NOUNS = {
  general:    { subject: 'Subject',  subjects: 'Subjects',  session: 'Session',   sessions: 'Sessions' },
  clinic:     { subject: 'Patient',  subjects: 'Patients',  session: 'Session',   sessions: 'Sessions' },
  healthcare: { subject: 'Patient',  subjects: 'Patients',  session: 'Encounter', sessions: 'Encounters' },
  legal:      { subject: 'Case',     subjects: 'Cases',     session: 'Interview', sessions: 'Interviews' },
  hr:         { subject: 'Employee', subjects: 'Employees', session: 'Interview', sessions: 'Interviews' },
  hls:        { subject: 'Case',     subjects: 'Cases',     session: 'Debrief',   sessions: 'Debriefs' },
};

export function nounsFor(vertical) {
  return NOUNS[vertical] || NOUNS.general;
}
